import React from 'react';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import AppointmentsAcademicSelectPart from './Academic';
import { StyledAppointmentsSelectPartForm, StyledAppointmentsSelectPartWrap } from './styled';

function AppointmentsSelectPart({ filters, locationMeet, onSubmit }: any) {

	return (
		<StyledAppointmentsSelectPartWrap>
			<Formik
				initialValues={{
					...filters,
					teacher_id: null,
				}}
				onSubmit={onSubmit}
			>
				<StyledAppointmentsSelectPartForm>
					<AppointmentsAcademicSelectPart locationMeet={locationMeet} />
				</StyledAppointmentsSelectPartForm>
			</Formik>
		</StyledAppointmentsSelectPartWrap>
	);
}

export default observer(AppointmentsSelectPart);
